'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AvShuffle = function AvShuffle(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M10.59 9.17L5.41 4 4 5.41l5.17 5.17 1.42-1.41zM14.5 4l2.04 2.04L4 18.59 5.41 20 17.96 7.46 20 9.5V4h-5.5zm.33 9.41l-1.41 1.41 3.13 3.13L14.5 20H20v-5.5l-2.04 2.04-3.13-3.13z' })
  );
};
AvShuffle = (0, _pure2.default)(AvShuffle);
AvShuffle.displayName = 'AvShuffle';
AvShuffle.muiName = 'SvgIcon';

exports.default = AvShuffle;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/av/shuffle.js
 ** module id = 1700
 ** module chunks = 0
 **/